import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject, timer } from 'rxjs';
import { map, takeWhile, last } from 'rxjs/operators';

/** Set by AuthGuard / header after /auth/context (or when both identity cookies arrive). */
export const SP_AUTH_CONTEXT_LOADED_KEY = 'spAuthContextLoadedAt';

@Injectable({
  providedIn: 'root',
})
export class GlobalComponent {
  totalCartItem: Subject<number>;

  constructor(private cookieService: CookieService) {
    this.totalCartItem = new Subject<number>();
  }

  public themecolor(): string {
    const themecolor = this.cookieService.get('themecolor');
    return themecolor;
  }

  public customerId(): string {
    const customerId = this.cookieService.get('customerId');
    return customerId;
  }

  public userId(): Guid {
    const userId = this.cookieService.get('userId');
    return userId as unknown as Guid;
  }

  public externalUserGUID(): Guid {
    const externalUserGUID = this.cookieService.get('externalUserGUID');
    return externalUserGUID as unknown as Guid;
  }

  /**
   * After OneLogin (JWT has no Chargebee / ExternalUserGUID claims), wait for
   * /auth/context or APIM response headers to populate cookies.
   * Completes when both are set, or when context has been attempted, or max wait.
   */
  public waitForSpIdentity(
    maxMs = 5000,
    intervalMs = 250
  ): Observable<{ customerId: string; externalUserGUID: string }> {
    const maxAttempts = Math.max(1, Math.ceil(maxMs / intervalMs));
    return timer(0, intervalMs).pipe(
      map((attempt) => {
        const customerId = (this.customerId() || '').trim();
        const externalUserGUID = String(this.externalUserGUID() || '').trim();
        const contextLoaded = !!sessionStorage.getItem(SP_AUTH_CONTEXT_LOADED_KEY);
        const hasBoth =
          !!customerId &&
          !!externalUserGUID &&
          externalUserGUID.toLowerCase() !== 'undefined';
        const ready =
          hasBoth || (contextLoaded && attempt >= 1) || attempt >= maxAttempts - 1;
        return { customerId, externalUserGUID, ready };
      }),
      takeWhile((state) => !state.ready, true),
      last(),
      map(({ customerId, externalUserGUID }) => ({ customerId, externalUserGUID }))
    );
  }
}
